export default {
  refreshOn: ({ group }) => [group],
  'AssignmentsList.ListHeader.MonthSelector.RightArrow': ({ assignmentsGroupIndex }, outlet) => {
    outlet({ assignmentsGroupIndex: assignmentsGroupIndex + 1 });
  },
  'AssignmentsList.ListHeader.MonthSelector.LeftArrow': ({ assignmentsGroupIndex }, outlet) => {
    outlet({ assignmentsGroupIndex: assignmentsGroupIndex - 1 });
  },
  'AssignmentsList.ListWrapper.AssignmentRow': ({ assignment }) => {
    if (assignment.id) {
      window.location.pathname = `orders/${assignment.id}`
    }
  },
  'AssignmentsList.LoadMore': ({ group, visibleAssignments }, _, internalStateSetter) => {
    internalStateSetter({ visibleAssignments: group.assignments.slice(0, visibleAssignments.length + 6) })
  },
  'AssignmentsList.ListWrapper.MutableAssignments': ({ value: { assignment, action, group } }, outlet) => {
    if (action === 'change_order') {
      outlet({ order_ids: group.assignments.map(a => ({ order_id: a.id, index: a.index })) })
    }
    if (action === 'on_click' && assignment.id) {
      window.location.pathname = `orders/${assignment.id}`
    }

  }
}